var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('el-breadcrumb',{attrs:{"separator-class":"el-icon-arrow-right"}},[_c('el-breadcrumb-item',[_vm._v("Quản lý danh mục")]),_c('el-breadcrumb-item',[_vm._v("Người ký")])],1)]],2)}
var staticRenderFns = []

export { render, staticRenderFns }